import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { UserContext } from "../../context/UserContext";
import Icon from "../common/icons";
import { AccountMenu, BrandLogo, StudentTabBar, tabsFor } from "./StudentNav";
import ClosingBanner from "../common/ClosingBanner";

// Student pages that show this header, and the tab each one belongs to.
// Booking a session is part of Appointments.
const STUDENT_ROUTES = {
  "/result": "results",
  "/results": "results",
  "/programs": "programs",
  "/appointments": "appointments",
  "/book-appointment": "appointments",
  "/account": "profile",
};

const MENU_ITEMS = [
  { key: "profile", label: "Profile", icon: "user", to: "/account" },
  { key: "home", label: "Home", icon: "home", to: "/" },
];

const normalizePath = (pathname) => pathname.replace(/\/+$/, "") || "/";

export const isStudentRoute = (pathname) => normalizePath(pathname) in STUDENT_ROUTES;

function StudentHeader() {
  const { isAuthenticated, user, handleLogout } = useContext(UserContext);
  const { pathname } = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const activeTab = STUDENT_ROUTES[normalizePath(pathname)];
  const name = user?.full_name || "Student";
  const detail = [user?.organizational_level_name, user?.section_name].filter(Boolean).join(" · ");

  useEffect(() => {
    setMenuOpen(false);
  }, [pathname]);

  return (
    <>
      <header className="sh">
        <div className="sh-row">
          <BrandLogo />
          <nav className="sh-tabs" aria-label="Student">
            {tabsFor(user).map((tab) => (
              <Link
                key={tab.key}
                to={tab.to}
                className="sh-tab"
                aria-current={activeTab === tab.key ? "page" : undefined}
              >
                <Icon name={tab.icon} size={18} />
                <span className="sh-tab-label" data-label={tab.label}>{tab.label}</span>
              </Link>
            ))}
          </nav>
          {isAuthenticated && (
            <AccountMenu
              open={menuOpen}
              onOpenChange={setMenuOpen}
              name={name}
              detail={detail}
              items={MENU_ITEMS}
              onLogout={handleLogout}
            />
          )}
        </div>
      </header>
      <div className="sh-spacer" aria-hidden="true" />
      {/* C4: "Your ANNA account closes on Oct 15" while the guidance office is closing it */}
      <ClosingBanner />
      <StudentTabBar active={activeTab} />
    </>
  );
}

export default StudentHeader;
